/* eslint-disable no-await-in-loop */
/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper, CardHeader, Card, Tooltip } from '@mui/material';
import { useSnackbar } from 'notistack';
import CheckIcon from '@mui/icons-material/Check';
import LockIcon from '@mui/icons-material/Lock';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import TableSortLabel from '@mui/material/TableSortLabel';
import VideoCameraBackIcon from '@mui/icons-material/VideoCameraBack';
import VideocamOffIcon from '@mui/icons-material/VideocamOff';
import LinkedCameraIcon from '@mui/icons-material/LinkedCamera';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import LinearProgress from '@mui/material/LinearProgress';
import EventIcon from '@mui/icons-material/Event';
import TablePagination from '@mui/material/TablePagination';
import { useSelector } from 'react-redux';
import axiosInstance from '../../../utils/axiosInstance';


const SensorTable = ({ host }) => {
  const [loading, setLoading] = useState(true);
  const [sensorData, setSensorData] = useState([]);
  const [sensorStatus, setSensorStatus] = useState({});
  const [sensorRecordingStatus, setSensorRecordingStatus] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10); // Number of rows per page
  const [orderBy, setOrderBy] = useState('remoteDeviceLocation'); // Column to be sorted
  const [order, setOrder] = useState('asc'); // Sorting order (asc or desc)
  const { enqueueSnackbar } = useSnackbar();
  const cameraList = useSelector((state) => state.app.cameraList);



  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await axiosInstance
        .get(`${window.location.protocol}//${host}/api/v1/sensor/list`)
        .then((response) => {
          if (response.data) {
            const filteredList = response.data.filter((device) => !(Object.prototype.hasOwnProperty.call(device, 'state') && device.state === 'removed'));
            setSensorData(filteredList);
          }
        })
        .catch((error) => {
          enqueueSnackbar(`Error - Failed to get sensor list`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
          if (error.response.data == null)
            enqueueSnackbar(`Error - ${error.response.status}`, {
              variant: 'error',
              anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
            });
          else
            enqueueSnackbar(`Error - ${error.response.data.error_message}`, {
              variant: 'error',
              anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
            });
        });

      await axiosInstance
        .get(`${window.location.protocol}//${host}/api/v1/sensor/status`)
        .then((response) => {
          if (response.data) {
            setSensorStatus(response.data);
          }
        })
        .catch((error) => {
          enqueueSnackbar(`Error - Failed to get sensor status`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
          if (error.response.data == null)
            enqueueSnackbar(`Error - ${error.response.status}`, {
              variant: 'error',
              anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
            });
          else
            enqueueSnackbar(`Error - ${error.response.data.error_message}`, {
              variant: 'error',
              anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
            });
        });


      const parsedData = [];
      for (let i = 0; i < cameraList.length; i += 1) {
        if (cameraList[i].host === host) {
          console.log(cameraList[i].host);
          await axiosInstance
            .get(`${window.location.protocol}//${host}/api/v1/record/${cameraList[i].sensorId}/status`)
            .then((response) => {
              if (response.data) {
                console.log('response: ', response.data);
                const temp = {
                  name: cameraList[i].name,
                  recordingStatus: response.data.recordingStatus,
                  remoteDeviceName: cameraList[i].remoteDeviceName,
                  remoteDeviceLocation: cameraList[i].remoteDeviceLocation,
                  isRemoteSensor: cameraList[i].isRemoteSensor,
                  sensorId: cameraList[i].sensorId
                };
                parsedData.push(temp);
              }
            })
            .catch((error) => {
              console.log('Failed to get record status', error);
            });
        }
      }
      console.log('Sensor Recording Status', parsedData);
      setSensorRecordingStatus(parsedData);
      setLoading(false);
    }
    fetchData();
  }, []);

  const handleSortRequest = (columnId) => {
    if (orderBy === columnId && order === 'asc') {
      setOrder('desc');
    } else {
      setOrder('asc');
    }
    setOrderBy(columnId);
    setPage(0); // Reset page when changing sorting
  };

  const descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  };

  const getComparator = (order, orderBy) => order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);

  const stableSort = (array, comparator) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  };

  const getStatus = (sensorId) => {
    const status = sensorStatus[sensorId];
    return status ? status.errorCode : 'unknown';
  };

  const getRecordingStatus = (sensorId) => {
    for (let i = 0; i < sensorRecordingStatus.length; i += 1) {
      if (sensorRecordingStatus[i].sensorId === sensorId) {
        return sensorRecordingStatus[i].recordingStatus;
      }
    }
    return 'unknown'
  };

  const getTableCell = (val) => {
    if (val === 'CameraUnauthorizedError') {
      return (
        <Tooltip title={val}>
          <LockIcon sx={{ color: 'error.main' }} />
        </Tooltip>
      );
    }
    if (val === 'NoError') {
      return (
        <Tooltip title={val}>
          <CheckIcon sx={{ color: 'secondary.main' }} />
        </Tooltip>
      );
    }
    if (val === 'error' || val === 'statusUnknown') {
      return (
        <Tooltip title={val}>
          <ErrorOutlineIcon sx={{ color: 'error.main' }} />
        </Tooltip>
      );
    }
    if (val === 'user' || val === 'schedule' || val === 'alwaysOn') {
      return (
        <Tooltip title={val}>
          <VideoCameraBackIcon sx={{ color: 'secondary.main' }} />
        </Tooltip>
      );
    }
    if (val === 'off') {
      return (
        <Tooltip title={val}>
          <VideocamOffIcon sx={{ color: 'error.main' }} />
        </Tooltip>
      );
    }
    if (val === 'event') {
      return (
        <Tooltip title={val}>
          <EventIcon sx={{ color: 'secondary.main' }} />
        </Tooltip>
      );
    }
    return (
      <Tooltip title={val}>
        <ErrorOutlineIcon sx={{ color: 'error.main' }} />
      </Tooltip>
    );
  };

  const sortedData = stableSort(
    sensorData,
    getComparator(order, orderBy)
  );

  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const paginatedData = sortedData.slice(startIndex, endIndex);

  return (
    <>
      <Card variant="outlined">
        <CardHeader title={'Sensor list'} subheader={'List of connected sensors'} />
        {
          loading && <LinearProgress color="inherit" sx={{ m: 2 }} />
        }
        {
          !loading &&
          <>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'name'}
                        direction={orderBy === 'name' ? order : 'asc'}
                        onClick={() => handleSortRequest('name')}
                      >
                        Sensor Name
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'status'}
                        direction={orderBy === 'status' ? order : 'asc'}
                        onClick={() => handleSortRequest('status')}
                      >
                        Sensor Status
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'recordingStatus'}
                        direction={orderBy === 'recordingStatus' ? order : 'asc'}
                        onClick={() => handleSortRequest('recordingStatus')}
                      >
                        Sensor Recording Status
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'remoteDeviceName'}
                        direction={orderBy === 'remoteDeviceName' ? order : 'asc'}
                        onClick={() => handleSortRequest('remoteDeviceName')}
                      >
                        Device Name
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'remoteDeviceLocation'}
                        direction={orderBy === 'remoteDeviceLocation' ? order : 'asc'}
                        onClick={() => handleSortRequest('remoteDeviceLocation')}
                      >
                        Device Location
                      </TableSortLabel>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedData.map((sensor) => (
                    <TableRow key={sensor.sensorId}>
                      <TableCell sx={{ display: 'flex', alignItems: 'center' }}><span style={{ marginRight: '8px' }}>{sensor.name}</span> {sensor.isRemoteSensor ? <LinkedCameraIcon sx={{ color: 'secondary.main' }} /> : <PhotoCameraIcon sx={{ color: 'secondary.main' }} />}</TableCell>
                      <TableCell>{getTableCell(getStatus(sensor.sensorId))}</TableCell>
                      <TableCell>{getTableCell(getRecordingStatus(sensor.sensorId))}</TableCell>
                      <TableCell>
                        {sensor.remoteDeviceName}
                      </TableCell>
                      <TableCell>{sensor.remoteDeviceLocation}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer><TablePagination
              rowsPerPageOptions={[10]}
              component="div"
              count={sortedData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={(event, newPage) => setPage(newPage)}
              onRowsPerPageChange={(event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
              }} />
          </>
        }

      </Card>
    </>
  );
};

export default SensorTable;